import React from 'react';

interface GlassXLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

export const GlassXLogo: React.FC<GlassXLogoProps> = ({ 
  width = 100, 
  height = 32, 
  className 
}) => {
  return (
    <div 
      className={className}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        background: 'url("/GlassXLogo.svg") no-repeat center center',
        backgroundSize: 'contain'
      }}
    />
  );
};
